import React from 'react';
import classes from './index.module.scss';
import { Link } from 'react-router-dom';

const ContractOppPostTableBody = ({ list, deletePost }) => {
  return (
    <>
      {
        list.map(item => {
          const { required_date, name, id, agency_name } = item;
          return (
            <tr 
              key={id}
            >
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{required_date}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{name}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>Federal Contract</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{agency_name}</td>
              <td className={classes.Vertical_Middle}>
                <Link
                  to={`/purchase?id=${id}`}
                  className="btnSizes filledBtn"
                >
                  View
                </Link>
                <button
                  className="btnSizes transparentBtn ml-4"
                  onClick={() => deletePost(id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          )
        })
      }
    </>
  )
}

export default ContractOppPostTableBody;